import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from 'styled-components'
import { media } from "utils/Media"
import Countdown from 'react-countdown-now'
import Text from "components/shared/Text"

const CountdownStyled = styled.div`
	color: ${props => props.theme.colors.white};
	background: ${props => props.theme.colors.primary};
	position: relative;
	padding: 1rem 2rem;
	text-align: center;
	justify-content: center;

	p {
		font-family: ${props => props.theme.font.family.bold};
	}

	strong {
		color: ${props => props.theme.colors.white};
	}

	@media ${media.md} {
		display: flex
	}

	.num {
		color: ${props => props.theme.colors.secondary};
	}
`

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	if (completed) {
		// Render a completed state
		return null
	} else {
		// Render a countdown
		return(
			<>
				<strong className="num">{days}</strong> &nbsp; DAYS &nbsp; <strong className="num">{hours}</strong> &nbsp; HOURS &nbsp; <strong className="num">{minutes}</strong> &nbsp; MINUTES <span className="d-none d-md-inline">&nbsp; <strong className="num">{seconds}</strong> &nbsp; SECONDS</span>
			</>
		)
	}
};

const HeaderCountdown = (props) => {
	let date = props.data.headerCountdown.split(',')
	let year = date[0]
	let month = date[1] - 1
	let day = date[2]
	let minutes = date[3]
	let secs = date[4]
	
	date = new Date(year, month, day, minutes, secs)
	
	return (
		<CountdownStyled>
			<Text orangeDark bold uppercase className="mb-0 pr-md-4"><strong>{props.data.countdownText}</strong></Text>
			<Countdown
				date={date}
				renderer={renderer}
			/>
		</CountdownStyled>
	)
}

export default () => (
	<StaticQuery
		query={graphql`
		query {
			allWp {
				edges {
					node {
						options {
							acfOptions {
								countdownText
								headerCountdown
								displayCountdown
							}
						}
					}
				}
			}
		}
		`}
		render={data => {
			if (data.allWp.edges[0].node.options.acfOptions.displayCountdown === "yes" && data.allWp.edges[0].node.options.acfOptions.headerCountdown) {
				return (
					<HeaderCountdown data={data.allWp.edges[0].node.options.acfOptions} />
					)
				} else {
					return ""
				}
		}}
	/>
)